import { ref, onValue, remove } from "firebase/database";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { database } from "../firebase";

function IncomingCall({ currentUserId }) {
	const [callData, setCallData] = useState(null);
	const audioRef = useRef(null);
	const navigate = useNavigate();
	const [showCancelModal, setShowCancelModal] = useState(false);

	useEffect(() => {
		if (!currentUserId) return;
		const callRef = ref(database, `calls/${currentUserId}`);
		console.log("📥 Listening to calls/" + currentUserId);

		const unsub = onValue(callRef, (snapshot) => {
			const data = snapshot.val();
			console.log("📡 Incoming call data:", data);
			setCallData(data || null);
		});

		return () => unsub();
	}, [currentUserId]);

	useEffect(() => {
		if (!audioRef.current) return;
		if (callData?.status === "incoming") {
			audioRef.current.play().catch(() => {});
		} else {
			audioRef.current.pause();
			audioRef.current.currentTime = 0;
		}
	}, [callData]);

	// Defensive wrapper for accepting call
	const acceptCall = () => {
		try {
			remove(ref(database, `calls/${currentUserId}`));
			if (audioRef.current) {
				audioRef.current.pause();
				audioRef.current.currentTime = 0;
			}
			if (callData?.roomId) {
				navigate(`/room/${callData.roomId}?type=one-on-one`);
			}
		} catch (err) {
			console.error("Error on acceptCall:", err);
		}
	};

	// Defensive wrapper for canceling call
	const cancelCall = async () => {
		try {
			console.log("Cancelling call for both users...");

			// Remove call for current user
			await remove(ref(database, `calls/${currentUserId}`));

			// Remove call for the other user (caller or receiver)
			// Use callData.callerId and callData.receiverId to remove both
			if (callData?.callerId && callData.callerId !== currentUserId) {
				await remove(ref(database, `calls/${callData.callerId}`));
			}

			if (callData?.receiverId && callData.receiverId !== currentUserId) {
				await remove(ref(database, `calls/${callData.receiverId}`));
			}

			audioRef.current?.pause();
			audioRef.current.currentTime = 0;

			setCallData(null);
			setShowCancelModal(false);
		} catch (err) {
			console.error("Error on cancelCall:", err);
		}
	};

	if (!callData || callData.status !== "incoming") return null;

	return (
		<div style={styles.box}>
			<img src={callData.callerPhoto} alt="caller" style={styles.img} />
			<h3>{callData.callerName} is calling...</h3>
			<button onClick={acceptCall} style={styles.button}>
				Accept
			</button>

			<button onClick={cancelCall} style={styles.buttonCancel}>
				Cancel
			</button>

			<audio ref={audioRef} src="/ringtone.mp3" loop preload="auto" />

			{showCancelModal && (
				<div style={modalStyle}>
					<h4>Are you sure you want to cancel the call?</h4>
					<button
						onClick={() => {
							remove(ref(database, `calls/${currentUserId}`));
							setShowCancelModal(false);
							setCallData(null);
							if (audioRef.current) {
								audioRef.current.pause();
								audioRef.current.currentTime = 0;
							}
						}}
						style={{
							marginRight: 10,
							padding: "10px 20px",
							borderRadius: 5,
							backgroundColor: "#dc3545",
							color: "#fff",
							border: "none",
						}}
					>
						Yes, Cancel Call
					</button>
					<button
						onClick={() => setShowCancelModal(false)}
						style={{
							padding: "10px 20px",
							borderRadius: 5,
							backgroundColor: "#6c757d",
							color: "#fff",
							border: "none",
						}}
					>
						No, Go Back
					</button>
				</div>
			)}
		</div>
	);
}

const styles = {
	box: {
		position: "fixed",
		bottom: 20,
		right: 20,
		padding: 20,
		background: "#fff",
		borderRadius: 10,
		boxShadow: "0 0 10px rgba(0,0,0,0.3)",
		zIndex: 999,
		textAlign: "center",
	},
	buttonAccept: {
		marginTop: 10,
		backgroundColor: "#28a745",
		color: "#fff",
		padding: "10px 20px",
		border: "none",
		borderRadius: 5,
		marginRight: 10,
	},
	buttonCancel: {
		marginTop: 10,
		backgroundColor: "#dc3545",
		color: "#fff",
		padding: "10px 20px",
		border: "none",
		borderRadius: 5,
	},
	img: { width: 80, height: 80, borderRadius: "50%" },
	button: {
		marginTop: 10,
		backgroundColor: "#28a745",
		color: "#fff",
		padding: "10px 20px",
		border: "none",
		borderRadius: 5,
	},
};

const modalStyle = {
	position: "fixed",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	background: "#fff",
	padding: 20,
	boxShadow: "0 0 10px rgba(0,0,0,0.3)",
	borderRadius: 8,
	zIndex: 1111111111,
	textAlign: "center",
};

export default IncomingCall;
